import * as React from 'react';

const StarLister24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M14.744 7.815a1.96 1.96 0 1 0-3.768-.75h-1.5a3.459 3.459 0 1 1 4.209 3.377v1.166c.106.035.21.077.313.126l6.479 3.136c2.335 1.13 1.53 4.64-1.064 4.64H8.403l.505-1.5h10.505c1 0 1.311-1.354.41-1.79l-6.479-3.136a.942.942 0 0 0-.82 0l-.541.262-1.936-.73 1.823-.882c.103-.05.208-.091.315-.126v-1.27c0-.754.598-1.238 1.155-1.356a1.958 1.958 0 0 0 1.404-1.167Z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "m4.243 16.869.716 2.15.283.85c.234.699 1.225.699 1.459 0l.999-3 2.996-.998c.701-.234.701-1.225 0-1.458L7.7 13.415l-1-3c-.233-.699-1.224-.699-1.458 0l-.999 3-2.998.998c-.7.233-.7 1.224 0 1.458l2.998.998ZM21.518 8.01l1.499.499c.35.117.35.612 0 .729l-1.499.499-.5 1.5a.385.385 0 0 1-.728 0l-.5-1.5-1.499-.5a.384.384 0 0 1 0-.728l1.5-.5.499-1.499a.385.385 0 0 1 .729 0l.5 1.5Z"
  }
));
StarLister24.Size = 24;
StarLister24.Title = "StarLister";

export { StarLister24 as default };
